import { Injectable, Inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  MsalInterceptor,
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptorConfiguration, MsalService, MsalBroadcastService
} from '@azure/msal-angular';
import { Location, DOCUMENT, PlatformLocation} from '@angular/common';

import { InteractionStatus } from '@azure/msal-browser';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { timeout } from 'rxjs';


@Injectable()
export class CustomMsalInterceptor extends MsalInterceptor implements HttpInterceptor {
  private theMsalBroadcastService: MsalBroadcastService;
  private baseStored = false; // prevent repeated write

  constructor(
    @Inject(MSAL_INTERCEPTOR_CONFIG) private config: MsalInterceptorConfiguration,
    private platformLocation: PlatformLocation,
     authService: MsalService,
     location: Location,
     msalBroadcastService: MsalBroadcastService,
    @Inject(DOCUMENT) doc: Document
  ) {
    // Order must match the base class constructor (config, service, location, broadcast, document?)
    super(config, authService, location, msalBroadcastService, doc);
    this.theMsalBroadcastService = msalBroadcastService;
  }



  override intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const isMsalAuthTrigger = req.headers.has('X-Auth-Trigger');

    const hasSkipHeader = req.headers.has('skip-msal');

    //skip MSAL completely if can't find 'X-Auth-Trigger' header in request or if already tried.
    if (!isMsalAuthTrigger || hasSkipHeader) {
      return next.handle(req);
    }




    // Wait for MSAL to finish any interactive operation (redirect/popup) before proceeding. Preventing UI from loading more times than it needs to,
    // when trying to acquire authentication token and other request (/login) coming after each application reload.
    return this.theMsalBroadcastService.inProgress$.pipe(

      // Only continue when MSAL reports it's idle. While busy, the status is not "None".
      filter(status => status === InteractionStatus.None),

      // Take the first idle signal and complete the subscription (prevents leaks/replays)
      take(1),

      // Safety net: if MSAL never becomes idle (e.g., stuck redirect), give up after 8s
      timeout({ first: 8000 }),


      // BEFORE we forward the request, check <base href>
      tap(() => {
        if (!this.baseStored) {
          const baseHref = this.platformLocation.getBaseHrefFromDOM() || '/';
          // Normalize: ensure it ends with a slash when present
          const normalized = baseHref || '/';

          // If not '/', store it once; otherwise do nothing
          if (normalized !== '/') {
            console.log('base href: ', normalized);
            sessionStorage.setItem('postLoginUrl', normalized);
          }
          this.baseStored = true;
        }
      }),


      // Once idle, defer to the base MSAL interceptor to attach tokens and forward the request
      switchMap(() => super.intercept(req, next)),

    );

  }
}
